import React from 'react'
import { AppContext } from '../App';
import { useContext } from 'react';
import { Link } from 'react-router-dom';

const PageCard = (props) => {


    const [cart,setCart]=useContext(AppContext);
    function AddToCart(product,e)
    {
        e.preventDefault();
        const _cart={...cart};

        const id=product.id;
        if(_cart.items[id])
        {
            _cart.items[id]++;
        }
        else
        {
            _cart.items[id]=1;
        }
        _cart.itemsCount++;
        
        _cart.totalPrice+=product.price;
        console.log(_cart.totalPrice);

        setCart(_cart);
    }
    function BuyNow(e)
    {
        e.preventDefault();
    }

    return (
        <div>
            <Link to={`/SingleProduct/${props.Product.id}`}>
            <div className='bg-white shadow-lg shadow-violet-300 w-full border-[2px] rounded-lg  border-violet-400 md:p-10 p-2'>
                <img src={props.Product.image} className="w-[100%] md:max-h-[400px] md:min-h-[400px] max-h-[150px] min-h-[150px] object-contain" />

                <div className="relative md:h-[500px] h-[260px] md:p-3 p-2 overflow-hidden flex flex-col items-center md:gap-5 gap-3">
                    <h3 className="text-violet-900 md:text-3xl text-sm leading-4 overflow-text-3 text-ellipsis text-center min-h-[3em]">{props.Product.title}</h3>
                    <p className="md:text-lg text-[10px] text-gray-800 leading-1 text-center overflow-text-3">{props.Product.description}</p>
                    <span className="md:text-xl text-sm rounded pl-2 bg-violet-500 flex justify-center items-center align-center content-center">{props.Product.rating.rate} ⭐</span>
                    <span className="text-violet-800 md:text-xl text-xs">{props.Product.rating.count} Orders Till Now</span>
                    <span className="text-green-700 font-bold md:text-4xl text-sm">Rs. {props.Product.price} Only</span>
                    <div className='absolute bottom-0 w-full md:min-h-[50px] min-h-[30px]   grid grid-cols-2 md:gap-3 gap-1'>
                        <button onClick={(e)=>{AddToCart(props.Product,e)}}  className="md:text-xl leading-4 text-sm w-full h-full shadow-lg rounded-lg bg-violet-700 text-white active:bg-violet-900 hover:cursor-pointer active:shadow-none active:text-gray-300">Add To Cart</button>
                        <button onClick={(e)=>{BuyNow(e)}} className="text-sm w-full h-full md:text-xl min-h-[50px] shadow-lg rounded-lg bg-green-600 text-white active:bg-green-700 hover:cursor-pointer active:shadow-none active:text-gray-300">Buy Now</button>
                    </div>

                    {/* <div className='w-full md:min-h-[50px] min-h-[30px]  grid grid-cols-2 absolute bottom-0 md:gap-3 gap-1'>
                        <button onClick={()=>{AddToCart(props.product)}} className=" leading-4 text-sm h-full shadow-xl rounded-lg bg-violet-700 text-white active:bg-violet-900 hover:cursor-pointer md:text-xl active:shadow-none active:text-gray-300 p-1">Add To Cart</button>
                        <button className="text-sm h-full shadow-xl rounded-lg bg-green-600 text-white active:bg-green-700 hover:cursor-pointer active:shadow-none active:text-gray-300 p-1 md:text-xl">Buy Now</button>
                    </div> */}
                </div>
            </div>
            </Link>
        </div>    
            )
}
export default PageCard